import React, { useState } from "react";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const Header = () => {
  const i18nLocale = useSelector((state) => state.i18nLocale);
  const intl = useIntl();
  const location = useLocation();

  const [selectedLanguage, setSelectedLanguage] = useState(i18nLocale || "en");

  const handleLanguageChange = (newLocale) => {
    const currentPathname = location.pathname;
    const newPathname = currentPathname.replace(`/${i18nLocale}`, `/${newLocale}`);
    setSelectedLanguage(newLocale);

    window.location.href = newPathname;
  };

  const data = {
    homeurl: `/${i18nLocale}`,
    lang: {
      current: {
        url: "/en",
        label: i18nLocale.toUpperCase(),
      },
      available: [
        {
          url: "en",
          label: "EN",
        },
        {
          url: "fr",
          label: "FR",
        },
        {
          url: "nl",
          label: "NL",
        },
      ].filter(lang => lang.label !== i18nLocale.toUpperCase()).slice(0, 2),
    },
    navigation: [
      {
        url: "#",
        label: intl.formatMessage({ id: "header.navigation.find_job.label" }),
        submenu: [
          {
            url: `/${i18nLocale}/jobs`,
            label: intl.formatMessage({ id: "header.navigation.find_job.submenu.open_careers" }),
          },
          {
            url: `/${i18nLocale}/why-us-candidate`,
            label: intl.formatMessage({ id: "header.navigation.find_job.submenu.why_us_candidate" }),
          },
          {
            url: `/${i18nLocale}/submit-your-cv`,
            label: intl.formatMessage({ id: "header.navigation.find_job.submenu.submit_cv" }),
          },
        ],
      },
      {
        url: `/${i18nLocale}/why-us-company`,
        label: intl.formatMessage({ id: "header.navigation.hire_talent.label" }),
        submenu: false,
      },
    ],
  };

  return (
    <header
      id="header"
      className="absolute-on-top fixed [#menu.is-open+&]:fixed top-0 left-0 w-full z-20 vw-h [--h:85] tablet:[--h:106] desktop:[--h:122] transition-[transform,background-color] [#home>&.absolute-on-top]:bg-transparent [#menu.is-open+&]:bg-transparent bg-deepBlue duration-300 ease-out-cubic transform translate-x-0 translate-y-0 [&.absolute-on-top]:absolute [&.scroll-hide]:-translate-y-full"
    >
      <div
        id="header-container"
        className="gg-container vw-px [--px:16] mini:[--px:30] tablet:[--px:36] desktop:[--px:48] h-full flex items-center justify-between mini:vw-gap [--gap:36]"
      >
        <a id="header-logo" href={data.homeurl}>
          <svg
            className="aspect-[195/29] vw-w [--w:140] laptop:[--w:162] desktop:[--w:194]"
            viewBox="0 0 195 29"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M89.782 0.7205C88.1878 0.730386 87.3662 1.22467 87.0435 2.48016C86.7892 3.48851 86.6131 4.55617 86.6033 5.59417C86.5642 10.7941 86.5838 15.9841 86.5838 21.184C86.5838 21.6091 86.5838 22.0342 86.5838 22.6866C86.2121 22.3901 86.0165 22.2714 85.8698 22.1034C83.679 19.6616 81.586 17.1308 79.2778 14.7978C74.8278 10.2998 70.2799 5.89074 65.7222 1.51136C64.6464 0.483242 63.2478 0.0284981 61.634 0.354728V27.0561C63.8639 26.6212 64.2552 26.2257 64.4899 24.1695C64.5877 23.2798 64.6757 22.3901 64.6757 21.5003C64.7051 16.5476 64.6953 11.5948 64.7148 6.64206C64.7148 6.2664 64.7637 5.90063 64.8029 5.23829C65.4288 5.79189 65.8298 6.11812 66.2015 6.474C72.6467 12.88 79.0724 19.3156 85.5373 25.6919C86.1143 26.2554 86.9163 26.6805 87.689 26.9276C89.2538 27.4417 89.7722 27.0067 89.782 25.3755C89.782 17.8624 89.782 10.3591 89.782 2.84594C89.782 2.16382 89.782 1.4817 89.782 0.7205ZM178.285 15.6677C179.468 14.9362 180.534 14.3233 181.551 13.6214C183.86 12.0397 184.261 9.67698 183.928 7.15612C183.605 4.68468 182.715 2.36153 180.035 1.64976C177.512 0.97753 174.901 0.463471 172.309 0.315185C168.514 0.0976983 164.69 0.285527 160.876 0.236099C159.78 0.216327 159.36 0.552443 159.369 1.6893C159.409 9.64733 159.399 17.6054 159.409 25.5634C159.409 25.9786 159.526 26.3938 159.604 26.8782C160.797 26.5915 161.736 26.1466 162.088 25.0987C162.392 24.1893 162.558 23.2007 162.568 22.2418C162.617 17.9415 162.587 13.6313 162.587 9.33098C162.587 7.38349 162.587 5.44589 162.587 3.45885C162.929 3.37977 163.203 3.25125 163.477 3.27102C168.084 3.50828 172.71 3.56759 177.287 4.07177C180.681 4.44743 180.612 5.73257 180.759 8.46104C180.808 9.36064 180.466 10.7446 179.83 11.1203C178.48 11.9309 176.857 12.5241 175.292 12.6625C172.152 12.9492 168.984 12.8602 165.824 12.9393C164.749 12.9591 164.309 13.5917 165.013 14.3628C165.668 15.0647 166.666 15.6084 167.614 15.8457C168.602 16.0928 169.717 15.994 170.764 15.8753C173.062 15.6084 174.891 16.1423 176.26 18.2183C177.786 20.5414 179.615 22.6669 181.17 24.9702C182.246 26.5618 185.072 27.6493 186.862 26.8288C183.948 23.0326 181.043 19.2464 178.304 15.6776L178.285 15.6677ZM0.086035 26.2059C0.653297 26.4531 1.11298 26.6805 1.60199 26.8485C5.00557 28.0052 8.51673 28.5291 12.1061 28.5686C16.1943 28.6181 20.0967 28.0249 23.5198 25.5337C25.2216 24.298 25.74 22.5482 25.6422 20.6304C25.5835 19.5924 25.2901 18.3764 24.6739 17.5856C23.0406 15.4799 20.7324 14.3035 18.1602 13.6016C14.4925 12.6032 10.8347 11.5652 7.16704 10.5667C5.6902 10.1614 4.52633 9.36064 3.7439 8.03595C3.13752 6.99795 3.20598 5.91052 4.18402 5.20863C5.18162 4.49685 6.30636 3.79497 7.48001 3.51817C12.0866 2.43073 16.654 2.99422 21.1726 4.18051C22.268 4.4672 23.1091 3.99268 23.5296 2.77674C23.8817 1.72885 22.9037 1.73873 22.4049 1.39273C22.1408 1.21479 21.8181 1.11593 21.5149 1.02696C17.7103 -0.0901309 13.8275 -0.100017 9.93489 0.0976983C7.48979 0.216327 5.12293 0.750157 2.98103 2.01553C1.07385 3.13262 0.174058 4.92194 0.0175723 7.03749C-0.168255 9.51881 1.13254 11.1895 3.31356 12.188C4.70238 12.8207 6.09119 13.4929 7.54847 13.9377C10.7564 14.9164 13.9742 15.8951 17.2506 16.6069C19.3241 17.0616 20.5955 18.4753 22.0332 19.7506C22.2484 19.9483 22.3071 20.4129 22.3071 20.7589C22.2777 22.0836 21.6127 23.1513 20.4879 23.7246C19.2849 24.3474 17.9744 24.9505 16.6442 25.1185C12.3213 25.682 7.99837 25.6029 3.75368 24.3771C1.46507 23.7147 1.36727 23.8136 0.0958154 26.2059H0.086035ZM153.335 0.374499C153.227 0.334956 153.12 0.265756 153.012 0.265756C146.156 0.265756 139.3 0.285527 132.454 0.245984C131.3 0.245984 131.124 0.799586 131.133 1.74862C131.153 9.62756 131.143 17.5065 131.153 25.3755C131.153 27.0067 131.27 27.1154 132.874 27.1154C139.525 27.1154 146.176 27.1154 152.826 27.1154C153.09 27.1154 153.345 27.0166 153.599 26.9672C153.257 24.8417 152.552 24.1695 150.655 24.1695C145.589 24.1695 140.513 24.1991 135.447 24.209C135.104 24.209 134.762 24.1695 134.4 24.1398V14.9362H152.406C151.829 12.5043 150.548 12.0594 148.601 12.0199C144.709 11.9408 140.816 11.9902 136.923 11.9902C136.092 11.9902 135.251 11.9902 134.4 11.9902V3.38965C134.977 3.34022 135.486 3.27102 136.004 3.27102C140.708 3.25125 145.413 3.25125 150.117 3.23148C152.171 3.23148 152.905 2.55925 153.325 0.384385L153.335 0.374499ZM42.8948 3.58737C43.687 5.1592 44.264 6.35537 44.8802 7.53178C48.0002 13.483 51.1201 19.4441 54.2694 25.3854C55.042 26.8386 56.646 27.4219 58.2598 26.898C58.0837 26.4135 57.9566 25.9094 57.7219 25.4546C56.6949 23.4775 55.6386 21.5201 54.5921 19.5528C51.6287 13.918 48.675 8.2831 45.6822 2.66799C45.3301 2.01553 44.7824 1.4125 44.1956 0.937987C42.9339 -0.100017 41.7309 0.11747 40.792 1.47182C40.5182 1.86725 40.2736 2.30222 40.0683 2.73719C38.7675 5.49532 37.2711 8.13481 35.5008 10.6161C35.7844 12.01 34.5619 12.8108 34.0827 13.8685C32.2244 17.9217 30.0923 21.8365 28.0775 25.8204C27.8917 26.1862 27.7645 26.5915 27.5885 27.0265C29.2609 27.155 31.1485 26.1763 31.7647 24.9406C32.4004 23.6752 32.9481 22.3505 33.6914 21.1543C33.9653 20.7095 34.6988 20.3239 35.227 20.314C39.0022 20.2547 42.7676 20.3042 46.5429 20.314C47.0906 20.314 47.6383 20.314 48.2251 20.314C47.7654 18.6434 46.7287 17.6943 45.2616 17.6251C42.709 17.4966 40.1661 17.4274 37.6134 17.3187C36.7918 17.289 36.0485 16.4388 36.4495 15.8358C36.9483 15.0944 37.3102 14.3628 37.6329 13.5225C38.1513 12.1583 39.1293 10.972 39.8335 9.6671C40.8409 7.77892 41.77 5.8512 42.8948 3.61702V3.58737ZM96.9217 27.2736C102.653 27.1352 108.365 27.1352 114.057 26.8288C120.228 26.5025 125.412 22.0045 125.725 15.4997C125.832 13.1568 125.872 10.883 125.197 8.53024C124.199 5.10977 122.047 2.79651 118.918 1.70907C116.326 0.809472 113.47 0.473357 110.712 0.32507C106.673 0.0976983 102.604 0.25587 98.555 0.275642C97.9877 0.275642 97.4205 0.473357 96.8336 0.5821C97.3813 2.46039 98.3105 3.21171 99.9829 3.22159C101.284 3.23148 102.575 3.23148 103.876 3.22159C108.218 3.14251 112.59 3.08319 116.795 4.23983C118.262 4.64514 119.964 5.56452 120.756 6.77058C122.4 9.27167 122.898 12.2967 122.566 15.2822C121.989 20.4524 120.209 22.4988 114.751 23.5763C111.915 24.1398 108.952 24.0311 106.037 24.1497C104.13 24.2288 102.223 24.1398 100.325 24.1794C98.3203 24.2288 97.2542 25.1877 96.9314 27.2637L96.9217 27.2736ZM96.9021 4.58583V23.2205C99.1222 22.6669 99.9927 21.5596 99.9927 19.2365C99.9927 16.8837 100.012 14.5309 99.9829 12.1781C99.9536 10.5173 99.9438 8.85647 99.758 7.20555C99.5721 5.58429 98.7799 4.92194 96.9021 4.58583ZM190.207 24.7231C190.187 26.3938 190.833 27.1154 192.368 27.1451C193.611 27.1649 194.589 26.1368 194.618 24.8022C194.638 23.5566 193.659 22.5383 192.437 22.5186C190.901 22.4988 190.227 23.1611 190.207 24.7231Z"
              fill="white"
            />
          </svg>
        </a>
        {data.lang && (
          <div id="header-lang" className="max-mini:hidden grow border-l border-white text-white vw-h [--h:36] vw-pl [--pl:24] vw-text [--text:16] vw-leading [--leading:20] vw-tracking [--tracking:1] flex items-center justify-start">
            <ul className="flex items-center justify-start vw-gap [--gap:24] h-full">
              <li
                key="header-lang-current"
                className="relative inline-flex h-full [&>ul]:transition-[opacity,transform] [&>ul]:duration-150 [&>ul]:ease-out-cubic [&>ul]:opacity-0 [&:hover>ul]:opacity-100 [&>ul]:transform [&>ul]:translate-y-1/4 [&:hover>ul]:translate-y-[-16px] [&>ul]:pointer-events-none [&:hover>ul]:pointer-events-auto"
              >
                {/* Display the selected language at the top */}
                <a onClick={() => handleLanguageChange(selectedLanguage)} className="flex items-center justify-start vw-gap [--gap:8]">
                  {selectedLanguage.toUpperCase()}
                  <svg
                    className="vw-w [--w:11] vw-h [--h:8]"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 11 8"
                    fill="none"
                  >
                    <path
                      d="M9.21506 1.10715L5.10742 5.60785L0.999787 1.10715"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </svg>
                </a>
                {data.lang.available && (
                  <ul className="absolute top-[calc(100%+16px)] vw-left [--left:-24] bg-white text-deepBlue vw-px [--px:24] vw-py [--py:8] vw-rounded [--rounded:24] flex flex-col shadow-black/10 shadow-2xl">
                    {data.lang.available.map((lang, index) => (
                      <li
                        key={`header-lang-${index}`}
                        className="vw-py [--py:16] [&:not(:last-child)]:border-b [&:not(:last-child)]:border-[#B2D0EC] overflow-hidden [--translate-x:-20] hover:[--translate-x:0] [&>div]:[transform:translateX(calc((var(--translate-x)/var(--current-screen-size))*var(--screen-w)))] [&>div]:tranition-[transform] [&>div]:duration-150 [&>div]:ease-out-cubic"
                      >
                        <div
                          className="flex items-center justify-start vw-gap [--gap:12]"
                          onClick={() => handleLanguageChange(lang.url)}
                          style={{ cursor: "pointer" }}
                        >
                          <svg
                            className="vw-w [--w:8] vw-h [--h:13]"
                            viewBox="0 0 8 13"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1.00028 1.49972L6.00055 6.5L1.00028 11.5003"
                              stroke="#346DE1"
                              strokeWidth="2"
                              strokeLinecap="round"
                            />
                          </svg>
                          <span dangerouslySetInnerHTML={{ __html: lang.label }}></span>
                        </div>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            </ul>
          </div>
        )}
        {data.navigation && (
          <div
            id="header-nav"
            className="max-tablet:hidden transition-[opacity,transform] duration-150 ease-out-cubic [#menu.is-open+#header_&]:opacity-0 [#menu.is-open+#header_&]:pointer-events-none vw-pr [--pr:16] laptop:[--pr:36] h-full inline-flex items-center"
          >
            <ul className="flex vw-gap [--gap:40] laptop:[--gap:80] text-white vw-text [--text:16] desktop:[--text:18] vw-tracking [--tracking:1] vw-leading [--leading:20]">
              {data.navigation.map((item, index) => (
                <li
                  key={`header-nav-${index}`}
                  className="relative vw-py [--py:24] [&>ul]:transition-[opacity,transform] [&>ul]:duration-150 [&>ul]:ease-out-cubic [&>ul]:pointer-events-none [&:hover>ul]:pointer-events-auto [&>ul]:opacity-0 [&:hover>ul]:opacity-100 [&>ul]:transform [&>ul]:translate-y-1/4 [&:hover>ul]:translate-y-[-24px] [&>ul]:whitespace-nowrap [&>ul]:min-w-[140%]"
                >
                  <a
                    href={item.url}
                    className="flex items-start justify-start vw-gap [--gap:16] [&_small]:vw-text [&_small]:[--text:13] desktop:[&_small]:[--text:14]"
                  >
                    <div dangerouslySetInnerHTML={{ __html: item.label }}></div>
                    {item.submenu !== undefined && item.submenu.length > 0 && (
                      <svg
                        className="vw-w [--w:15] vw-h [--h:9] vw-mt [--mt:8]"
                        viewBox="0 0 15 9"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.2121 1.10715L7.10498 7.21429L0.997834 1.10715"
                          stroke="white"
                          strokeWidth="2"
                          strokeLinecap="round"
                        />
                      </svg>
                    )}
                  </a>
                  {item.submenu !== undefined && item.submenu.length > 0 && (
                    <ul className="absolute top-[calc(100%+16px)] vw-left [--left:-24] bg-white text-deepBlue vw-px [--px:24] vw-py [--py:8] vw-rounded [--rounded:24] flex flex-col shadow-black/10 shadow-2xl">
                      {item.submenu.map((subitem, index) => (
                        <li
                          key={`header-subnav-${index}`}
                          className="vw-py [--py:16] [&:not(:last-child)]:border-b [&:not(:last-child)]:border-[#B2D0EC] overflow-hidden [--translate-x:-20] hover:[--translate-x:0] [&>a]:[transform:translateX(calc((var(--translate-x)/var(--current-screen-size))*var(--screen-w)))] [&>a]:tranition-[transform] [&>a]:duration-150 [&>a]:ease-out-cubic"
                        >
                          <a
                            href={subitem.url}
                            className="flex items-center justify-start vw-gap [--gap:12]"
                          >
                            <svg
                              className="vw-w [--w:8] vw-h [--h:13]"
                              viewBox="0 0 8 13"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M1.00028 1.49972L6.00055 6.5L1.00028 11.5003"
                                stroke="#346DE1"
                                strokeWidth="2"
                                strokeLinecap="round"
                              />
                            </svg>
                            <span
                              dangerouslySetInnerHTML={{
                                __html: subitem.label,
                              }}
                            ></span>
                          </a>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          </div>
        )}
        <a
          id="header-menu-btn"
          className="text-white flex items-center justify-center vw-gap [--gap:14]"
          href="#"
          aria-label="Toggle menu"
          role="button"
          data-menu-action="toggle"
        >
          <div className="font-medium vw-text [--text:16] vw-leading [--leading:20] vw-tracking [--tracking:1]">
            Menu
          </div>
          <svg
            className="object-contain overflow-visible vw-w [--w:38] vw-h [--h:17] inline-block [#menu.is-open+#header_&]:hidden"
            viewBox="0 0 38 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="0.574219"
              y1="0.5"
              x2="37.5742"
              y2="0.500003"
              stroke="white"
            />
            <line
              x1="0.574219"
              y1="16.5"
              x2="19.0742"
              y2="16.5"
              stroke="white"
            />
            <line x1="0.574219" y1="8.5" x2="19.0742" y2="8.5" stroke="white" />
          </svg>
          <svg
            className="object-contain overflow-visible vw-w [--w:38] vw-h [--h:34] hidden [#menu.is-open+#header_&]:inline-block"
            viewBox="0 0 34 34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              y="0.0498047"
              width="33.1924"
              height="33.8995"
              rx="16.5962"
              fill="#B2D0EC"
            />
            <line
              x1="21.5459"
              y1="12.4034"
              x2="12.3535"
              y2="21.5957"
              stroke="#346DE1"
            />
            <line
              x1="12.3536"
              y1="12.4033"
              x2="21.5459"
              y2="21.5957"
              stroke="#346DE1"
            />
          </svg>
        </a>
      </div>
    </header>
  );
};

export default Header;
